import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { apiPost, TOKEN_KEY } from "@/lib/shieldx";
import { useAuth } from "@/context/AuthContext";
import { Wordmark } from "@/components/shieldx/Logo";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || window.location.hash;
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sid) { navigate("/login", { replace: true }); return; }
    (async () => {
      try {
        const user = await apiPost("/auth/session", { session_id: sid });
        setUser(user);
        window.history.replaceState(null, "", "/app/command-center");
        navigate("/app/command-center", { replace: true });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, [location.hash, navigate, setUser]);

  return (
    <div className="grid min-h-screen place-items-center bg-slate-950">
      <div className="flex flex-col items-center gap-4">
        <Wordmark markSize={34} />
        <div className="flex items-center gap-2 text-sm text-slate-400">
          <Loader2 className="h-4 w-4 animate-spin text-blue-500" /> Establishing secure session…
        </div>
      </div>
    </div>
  );
}
